//-------------Importar librerias----------------------------
import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import styled from "styled-components";
import TodoDataService from '../../hooks/services'

// -----------Importar Componentes Personalizados------------------
import ModalBaseMui from "../../components/Modal_Mui";
import TarjetaBeneficios from "../../components/TarjetaBeneficios";

// -----------Importar Componentes de Terceros---------------------
import Slider from "react-slick";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import ImageListItem from '@mui/material/ImageListItem';

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import TarjetaVelacion from "../../components/TarjetaVelacion";

// -----------Importar Archivos Estaticos------------------
import './styles.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ------------------------Valores Constantes----------------------------
import Columba1 from '../../assets/Imagenes/Home/slider/columba1B.png'
import Columba1Movil from '../../assets/Imagenes/Home/slider/columbamovil.jpg'

import Columbalogo from '../../assets/Imagenes/Home/slider/Icono columba.png'

import VelacionCasa from '../../assets/Imagenes/Home/velacion en casa.png'
import VelacionSala from '../../assets/Imagenes/Home/velacion en sala.png'
import VelacionDirecto from '../../assets/Imagenes/Home/servicio directo.png'

import IconoBenficio1 from '../../assets/Imagenes/Home/IconoBenficio1.png'
import IconoBenficio2 from '../../assets/Imagenes/Home/IconoBenficio2.png'
import IconoBenficio3 from '../../assets/Imagenes/Home/IconoBenficio3.png'
import IconoBenficio4 from '../../assets/Imagenes/Home/IconoBenficio4.png'
import IconoBenficio5 from '../../assets/Imagenes/Home/IconoBenficio5.png'
import IconoBenficio6 from '../../assets/Imagenes/Home/IconoBenficio6.png'




import IconoCasa from '../../assets/Imagenes/Home/Icono_casa.png'
import IconoSala from '../../assets/Imagenes/Home/Icono_sala.png'
import IconoDirecto from '../../assets/Imagenes/Home/Icono_directo.png'
import ImgPlanFuturo from '../../assets/Imagenes/Home/Img plan a futuro.png'
import ImgSetsFunerarios from '../../assets/Imagenes/Home/Img sets funerarios.png'


import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { createTheme, ThemeProvider } from '@mui/material/styles';





import Marquesi1 from '../../assets/Imagenes/Home/marquesi1.png'
import Marquesi2 from '../../assets/Imagenes/Home/marquesi2.jpeg'
import Marquesi3 from '../../assets/Imagenes/Home/marquesi3.png'
import Marquesi4 from '../../assets/Imagenes/Home/marquesi4.png'
import Marquesi5 from '../../assets/Imagenes/Home/marquesi5.png'



import CallTO from '../../assets/Imagenes/Home/call_to.png'
import CallToMovil from '../../assets/Imagenes/Home/CallToMovil.png'
import VideoConmemeracion from '../../assets/Videos/conmemoración.mp4'
import VideoConmemeracionModal from '../../assets/Videos/Plan_futuro.mp4'

// const ListImagenVelacion = [VelacionCasa, VelacionSala, VelacionDirecto];

const ListTarjetas = [
  {
    Imagen: VelacionCasa,

    onClick: '/SetsFunerarios/Cobertura/2',
    ColorTarjeta: 'rgba(233, 30, 99, 0.88)',
    Icono: <img height='35px' alt="Icono Casa" src={IconoCasa} />,
    TituloContenido: 'Velación en casa',
    TituloSize: '28px',
    TituloColor: 'yellow',
    TituloWeight: '700 !important',
    TituloAlign: 'left',
    ParrafoContenido: 'Brinda un servicio funerario a tu ser querido en la comodidad, calidez e intimidad de tu hogar con amigos y familiares.',
    ParrafoSize: '18px',
    ParrafoColor: 'white',
    ParrafoWeight: 'normal',
    ParrafoAlign: 'left',
    ListaContenido: [
      'Traslados',
      'Equipo de velación y mobiliario',
      'Preservación',
      'Conmemoración',
      'Y más…',
      'Desde $10,500.00'
    ],
    ListaSize: 14,
    ListaColor: 'yellow',
    ListaWeight: 'normal',
    ListaAlign: 'left',
  },
  {
    Imagen: VelacionSala,
    onClick: '/SetsFunerarios/Cobertura/1',

    ColorTarjeta: 'rgba(217, 87, 41, 0.88)',
    Icono: <img height='35px' alt="Icono Sala" src={IconoSala} />,
    TituloContenido: 'Velación en sala',
    TituloSize: '28px',
    TituloColor: 'yellow',
    TituloWeight: '700 !important',
    TituloAlign: 'left',
    ParrafoContenido: 'Vive tu duelo en nuestras salas de velación con tranquilidad en compañía de familiares y amigos a tu ser querido cómodamente y sin preocupaciones.',
    ParrafoSize: '18px',
    ParrafoColor: 'white',
    ParrafoWeight: 'normal',
    ParrafoAlign: 'left',
    ListaContenido: [
      'Traslados',
      'Sala de velación 24 horas',
      'Preservación',
      'Conmemoración',
      'Y más…',
      'Desde $11,000.00'
    ],
    ListaSize: 14,
    ListaColor: 'yellow',
    ListaWeight: 'normal',
    ListaAlign: 'left',
  },
  {
    Imagen: VelacionDirecto,
    onClick: '/SetsFunerarios/Cobertura/3',

    ColorTarjeta: 'rgba(2, 76, 60, 0.88)',
    Icono: <img height='35px' alt="Icono Directo" src={IconoDirecto} />,
    TituloContenido: 'Servicio directo',
    TituloSize: '28px',
    TituloColor: 'yellow',
    TituloWeight: '700 !important',
    TituloAlign: 'left',
    ParrafoContenido: 'Servicio funerario directo, rápido y profesional. Si tu deseo o el de tu ser querido es evitar velación y hacer directamente su despedida; entierro o cremación.',
    ParrafoSize: '18px',
    ParrafoColor: 'white',
    ParrafoWeight: 'normal',
    ParrafoAlign: 'left',
    ListaContenido: [
      'Liberación',
      'Traslados',
      'Conmemoración',
      'Trámites',
      'Y más…',
      'Desde $9,000.00'
    ],
    ListaSize: 14,
    ListaColor: 'yellow',
    ListaWeight: 'normal',
    ListaAlign: 'left',
  },
]

const ListBeneficion =
  [

    {
      Imagen: IconoBenficio1,
      ColorTarjeta: '#D14081',
      TituloContenido: <p className='AlbertBold' > Contratación clara y sin <br />complicaciones</p>,
      ParrafoContenido: 'Olvídate del papeleo confuso o trámites largos. En Columba todo es transparente, digital y entendible. Te guiamos paso a paso, estés donde estés.'
    },
    {
      Imagen: IconoBenficio2,
      ColorTarjeta: '#D95729',
      TituloContenido: <p className='AlbertBold' >Ahorro real,<br /> precios accesibles</p>,
      ParrafoContenido: 'Al operar en línea, eliminamos costos innecesarios y te ofrecemos precios más accesibles que las funerarias tradicionales. ¡Paga menos sin sacrificar calidad ni atención!.'
    },
    {
      Imagen: IconoBenficio3,
      ColorTarjeta: '#024C3C',
      TituloContenido: <p className='AlbertBold' >Servicios completos<br /> y personalizados</p>,
      ParrafoContenido: 'Desde planes a futuro hasta servicios inmediatos, ofrecemos todo lo que necesitas: traslado, cremación o inhumación, trámites, velación, urnas, ataúdes y más. '
    },
    {
      Imagen: IconoBenficio4,
      ColorTarjeta: '#D14081',
      TituloContenido: <p className='AlbertBold' >Disponibilidad<br /> 24/7</p>,
      ParrafoContenido: 'Estamos contigo a cualquier hora, cualquier día, listos para atender emergencias o resolver tus dudas, sin importar si es de noche, fin de semana o día festivo.'
    },
    {
      Imagen: IconoBenficio5,
      ColorTarjeta: '#D95729',
      TituloContenido: <p className='AlbertBold' >En Columba Funerales, lo<br /> hacemos llevadero</p>,
      ParrafoContenido: 'Nuestro compromiso es ofrecerte facilidad funeraria, con calidez humana y atención a cada detalle. Estamos aquí para ayudarte a honrar la vida de quien parte.'
    },
    {
      Imagen: IconoBenficio6,
      ColorTarjeta: '#024C3C',
      TituloContenido: <p className='AlbertBold' >Innovación<br /> con corazón</p>,
      ParrafoContenido: 'Con nuestra conmemoración, reafirmamos nuestro compromiso con la facilidad funeraria, integrando tecnología con empatía para que cada familia viva una despedida digna.'
    }
  ]

const ListPlanesFuturo = ['100% Transferible', 'Mucho más económico', 'Pagos fijos y accesibles', 'Vigencia de 99 años', 'Sin preocupaciones']
const ListSetsFunerarios = ['Traslado', 'Ataúd', 'Trámites', 'Equipo de velación (sí es en casa)', 'Servicio de carroza']

class Home extends Component {
  state = {
    Conmemoracion: false,
    Route: null,
    windowWidth: window.innerWidth
  }

  ShowConmemoracion = () => {
    this.setState({ Conmemoracion: !this.state.Conmemoracion })
  }

  componentDidMount() {
    const handleResize = () => {
      this.setState({ windowWidth: window.innerWidth });
    };

    // Agregar el event listener para el evento 'resize'
    window.addEventListener('resize', handleResize);

    // Limpiar el event listener cuando el componente se desmonta
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }



  render() {
    const StyleDragArea = styled.div`

button{
font-size: 18px !important;
}



    
.btn_consultar {background-color: #d14081;
  color: white;
  width: 200px;
  margin: auto;
  padding: 9px 12px;
  border-radius: 6px;
  border:1px solid #d14081;

}
.btn_consultar:hover{
  color: #d14081;
    background-color: white;
    box-shadow: 0 0 0 1px rgb(255 39 136);
}
.btn_consultar:focus{
  color: #d14081;
    background-color: white;
    box-shadow: 0 0 0 1px rgb(255 39 136);
}
.btn_consultar:active{
  color: #d14081 !important;
  background-color: white !important;
  border-color: #d14081 !important;
 
}


.btn_consultarV3 {background-color: #d14081;
  color: white;
  width: 200px;
  margin: auto;
 display: flex ;
 padding:2px 12px;
align-items:center;
justify-content: center;

  border-radius: 6px;
  border:1px solid #d14081;

}
.btn_consultarV3:hover{
  color: #d14081;
    background-color: white;
    box-shadow: 0 0 0 1px rgb(255 39 136);
}
.btn_consultarV3:focus{
  color: #d14081;
    background-color: white;
    box-shadow: 0 0 0 1px rgb(255 39 136);
}
.btn_consultarV3:active{
  color: #d14081 !important;
  background-color: white !important;
  border-color: #d14081 !important;

}









  .btn_consultarV2 {
    background-color:#ffec00 !important;
    border-radius: 6px;
    font-size:18px !important;
    border: 2px solid #ffec00 !important;
    color: #484848;
    width: 200px !important;
    display: flex;

     padding: 8px 12px !important;

        justify-content:center;
align-items: center;
  }
  .btn_consultarV2:hover {
    background-color: white !important;
    border: 2px solid #ffec00 !important;
    color: #484848 !important;
  }

  .btn_consultarV2:disabled {
    background-color: #c8cacb !important;
    border: 1px solid #c8cacb !important;
    color: #484848 !important;

  }



.boton_amarilo_comienza{
  width: 250px !important;
  height: 49px;
  font-size: 20px;
}
.boton_amarillo{
  padding: 5px 22px;
    background-color: #FFEC00;
    color: #484848;
    border: none;
  
    border-radius: 5px;
}
.boton_amarillo:hover{
  border: 1px solid #FFEC00;
    background-color: white;
    color: #6e6e6e;
}
.boton_amarillo:not(:disabled):not(.disabled).active, .boton_amarillo:not(:disabled):not(.disabled):active, .show>.boton_amarillo.dropdown-toggle {
  color: #fff;
background-color: #BFB31C;
border-color: #938a1e;
}

    `;



    const settings = {
      autoplay: true,
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
    };


    let { Route } = this.state;
    let theme = createTheme();

    return (


      <Box>
        {Route && (
          <Navigate to={Route} replace={true} />
        )}
        <Box className="page-wrapper">

          <Box className="hero-slider">
            <Slider  {...settings}>
              <Box className="slider-item new_slider" sx={{ backgroundImage: { xs: `url(${Columba1Movil})`, sm: `url(${Columba1})` } }}>

                <Box className="container">
                  <Box className="row" mr={0} ml={0} padding={0}>
                    <Box className={this.state.windowWidth < 1000 ? "col-12" : "col-6"} sx={{ width: { xs: '100%', sm: '610px' }, borderRadius: '15px', background: '#e57c4c' }} padding={0}>
                      <Box className="content style text-left" sx={{ margin: { xs: '25px 20px', sm: '75px 40px' } }}>
                        <Box display='flex' >
                          <Typography variant="h1" textAlign='left' width='auto' fontSize={{ xs: '13px', sm: '16px' }} sx={{ background: '#D95729', padding: '7px 14px', borderRadius: '5px' }} color='white' className="itacaBlack">Facilidad funeraria en Toluca. Contratación 100% en línea</Typography>
                        </Box>
                        <Typography variant="h2" className="text-bold" mb='25px' mt='25px' data-animation-in="slideInLeft"
                          sx={{ textAlign: 'left', opacity: '1', padding: '0px 5px', color: 'rgb(255, 255, 255) !important', fontSize: { xs: '30px !important', sm: '38px !important' }, borderRadius: '5px' }}>Despide con tranquilidad y amor.
                        </Typography>

                        <Typography sx={{ fontSize: { xs: '16px !important', sm: '18px !important' }, color: 'rgb(255, 255, 255) !important', textAlign: 'left' }} mb='25px'>
                          Brinda un <span className="AlbertBold">servicio funeral cálido a tus seres queridos</span> en la comodidad de tu hogar o en nuestras instalaciones.
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                          <StyleDragArea>
                            <button onClick={() => (this.setState({ Route: '/SetsFunerarios' }))} data-animation-in="slideInRight" type="button"
                              className="btn btn-block btn_consultarV2">Contrata aquí <img alt="logo boton" style={{ marginLeft: '10px' }} src={Columbalogo} />  </button>
                          </StyleDragArea>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Slider>
          </Box>
          {/* </div > */}


        </Box >

        {/* --- */}

        {
          this.state.windowWidth !== ''
            ?
            <Box id='DivSeccion2'>
              <ImageListItem  >
                <img alt="imagen fondo" id="ImagenSeccion2" src={this.state.windowWidth === ''
                  ? Marquesi1
                  : this.state.windowWidth < 650
                    ? this.state.windowWidth < 420 ? this.state.windowWidth < 380 ? Marquesi5 : Marquesi4 : Marquesi3
                    : this.state.windowWidth < 1300
                      ? Marquesi2
                      : Marquesi1} />
                <Box sx={{ position: 'absolute', width: { xs: '96%', sm: '97', md: '98%', lg: '99%' }, zIndex: 21, top: this.state.windowWidth === '' ? '0%' : this.state.windowWidth < 600 ? '0%' : '0%' }} >
                  <Box className="row MyComponent2" sx={{ paddingLeft: '0px !important', paddingRight: '0px !important' }}>
                    <Box className="col-md-12" textAlign={{ sx: 'left', sm: 'center' }} sx={{ paddingLeft: { xs: '35px !important', sm: '15px !important' }, paddingRight: { xs: '10px !important', sm: '0px !important' } }}>
                      <Typography mt='2rem' variant="h2" className="animate__animated animate__fadeIn animate__delay-1s TituloSeccion2">
                        Facilidad, Dignidad y Calidez:
                      </Typography>
                      <Typography mb='1.5rem' variant="h2" className="animate__animated animate__fadeIn animate__delay-1s TituloSeccion2">
                        Así Somos en Columba Funerales
                      </Typography>
                      <Typography className="ContenidoSeccion2">
                        Somos la primera e-commerce funeraria en Toluca, brindamos servicios funerarios accesibles,
                        <Typography className="ContenidoSeccion2"> de alta calidad y de fácil contratación en línea. Esto significa que ahora es más </Typography>
                        <Typography className="ContenidoSeccion2">fácil planificar un funeral desde cualquier lugar y desde tu celular, tablet o computadora.  </Typography>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </ImageListItem>
            </Box>
            :
            <></>
        }

        <div >


          <section className=" MyComponent" >
            <div className="container">
              <div className="row">
                <div className="col-md-12  text-center">
                  <Typography mt={{ xs: '70px', sm: '120px' }} variant="h2" sx={{ textAlign: 'center', fontSize: { xs: '25px', sm: '32px' }, color: '#D14081' }} className="animate__animated animate__fadeIn animate__delay-1s">¿Cómo funcionan nuestros servicios?
                  </Typography>
                </div>
              </div>
              <div className="row">
                <Box className="col-md-12 " sx={{ padding: { xs: '0% 20px', sm: '0% 4%', md: '0% 6%', lg: '0% 8%', xl: '0% 10%' }, textAlign: { xs: 'center', sm: 'center' } }}>
                  <Typography mb={{ xs: '25px', sm: '30px' }} mt={{ xs: '22px', sm: '50px' }} sx={{ fontSize: { xs: '16px', sm: '18px' }, color: '#D14081' }} >
                    Nuestro objetivo es simplificar el proceso funerario para brindarte un servicio integral y así ofrecerte tranquilidad y confianza de que tu ser querido está en las mejores manos, te apoyamos con todos los trámites
                    y logística para que tú y tu familia puedan centrarse en conmemorar la vida de su ser querido. Tener una experiencia sencilla y menos estresante es nuestra prioridad.
                  </Typography>
                </Box>
              </div>
              <div className="row">
                <div style={{}} className="animate__animated animate__bounceIn animate__delay-2s col-sm-3 text-center p-0">
                  <div className="personaliza linestep">
                  </div>
                  <Typography className="mt-2 mb-0 setstexto AlbertBold" sx={{ fontSize: { xs: '20px', sm: '22px' } }}>Selecciona</Typography>
                  <Typography className="mt-0" sx={{ fontSize: { xs: '16px', sm: '18px' }, lineHeight: '20px' }}> Conoce nuestros sets y<br />elige el que te interesa.</Typography>
                </div>
                <div style={{}} className="animate__animated animate__bounceIn animate__delay-2s col-sm-3 text-center p-0">
                  <div className="selecciona linestep">
                  </div>
                  <Typography className="mt-2 mb-0 setstexto AlbertBold" sx={{ fontSize: { xs: '20px', sm: '22px' } }}>Personaliza</Typography>
                  <Typography className="mt-0" sx={{ fontSize: { xs: '16px', sm: '18px' }, lineHeight: '20px' }}>Adapta el set
                    <br /> y elige tus extras.</Typography>
                </div>
                <div style={{}} className="animate__animated animate__bounceIn animate__delay-2s col-sm-3 text-center p-0">
                  <div className="ordena linestep">
                  </div>
                  <Typography className="mt-2 mb-0 setstexto AlbertBold" sx={{ fontSize: { xs: '20px', sm: '22px' } }}>Ordena y paga</Typography>
                  <Typography className="mt-0" sx={{ fontSize: { xs: '16px', sm: '18px' }, lineHeight: '20px' }}>Revisa tu compra e ingresa <br />los datos de tu
                    tarjeta.</Typography>
                </div>
                <div style={{}} className="animate__animated animate__bounceIn animate__delay-2s col-sm-3 text-center p-0">
                  <div className="confirma linestep">
                  </div>
                  <Typography className="mt-2 mb-0 setstexto AlbertBold" sx={{ fontSize: { xs: '20px', sm: '22px' } }}>Confirmación telefónica</Typography>
                  <Typography className="mt-0" sx={{ fontSize: { xs: '16px', sm: '18px' }, lineHeight: '20px' }}>Espera nuestra llamada<br />
                    para finalizar tu proceso.</Typography>
                </div>

                <div style={{}} className="animate__animated animate__bounceIn animate__delay-2s col-sm-3 text-center p-0">
                  <div className="extraSer linestep">
                  </div>
                </div>
                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: { xs: '25px', sm: '40px' } }} className="col-md-12 text-right  align">
                  <StyleDragArea>
                    <button onClick={() => (this.setState({ Route: '/SetsFunerarios' }))} className="btn btn_consultarV3 boton-con-imagen">Comienza ahora <span className="img-container" /></button>

                  </StyleDragArea>

                </Box>


              </div>
            </div>
          </section>


          <Container maxWidth='lg'>
            <section style={{ margin: '0px 30px 0px 30px' }} className=" MyComponent" >
              <div className="row ">
                <div className="col-lg-12">
                  <Typography mb={{ xs: '0px', sm: '20px' }} mt={{ xs: '70px', sm: '120px' }} variant="h2" sx={{ padding: { xs: '0px 0%', md: '0px  20%' }, fontSize: { xs: '25px', sm: '32px' }, color: '#d14081', textAlign: { xs: 'center', sm: 'center' } }} className="animate__animated animate__fadeIn animate__delay-1s ">¿Qué servicios funerarios tenemos para las personas de Toluca y alrededores?</Typography>
                </div>
              </div>
              <div className="row " style={{ display: 'flex', justifyContent: 'center' }}>
                {
                  ListTarjetas.map((item, index) => (
                    <Box key={index} className="col-12 col-sm-12 col-md-6 col-lg-4  d-flex " mt={{ xs: '30px' }}>
                      <div style={{ width: '100%', height: '100%' }}>
                        <TarjetaVelacion ParrafoMargin={index == 0 ? '8px 0px 33px 0px' : '8px 0px 12px 0px'} Margin='0px' Height={{ [theme.breakpoints.down(576)]: { height: '460px' }, [theme.breakpoints.up(576)]: { height: '500px' } }} ParrafoSize={{ [theme.breakpoints.down(576)]: { fontSize: '16px' }, [theme.breakpoints.up(576)]: { fontSize: '18px' } }} Imagen={item.Imagen} onClick={() => (this.setState({ Route: item.onClick }))} ColorTarjeta={item.ColorTarjeta} Icono={item.Icono} TituloContenido={item.TituloContenido} ParrafoContenido={item.ParrafoContenido} ListaContenido={item.ListaContenido} />
                      </div>
                    </Box>
                  ))
                }
              </div>
            </section>
          </Container>


          <Box sx={{ backgroundColor: '#fffcde', marginTop: { xs: '70px', sm: '120px' }, paddingTop: { xs: '55px', sm: '70px' }, paddingBottom: { xs: '50px', sm: '80px' } }}>
            <Container maxWidth='lg' >
              <section className="" style={{ margin: '0px 0px' }}>
                <Box className='ContenedorTituloServicios'>
                  <Typography variant="h2" className="TituloServicio itacaBlack" padding={{ xs: '7px 10px !important', sm: '7px 14px !important' }} >
                    Nuestros servicios funerarios
                  </Typography>
                </Box>
                <Typography variant="h2" className="SubTituloServicio" >
                  En Columba Funerales, estamos contigo cuando más lo necesitas.
                </Typography>
                <Typography className="ContenidoServicio">
                  En Columba Funerales te ofrecemos un servicio completo, claro y humano, pensado para acompañarte con respeto, empatía y facilidad.
                  Nuestros servicios incluyen todo lo que necesitas para despedir con dignidad a tu ser querido puedes elegirlos para uso inmediato o preventivos.
                </Typography>
              </section>
            </Container>
            <Container maxWidth='lg' className="contenedorGuilty" >

              <div className="row contenedorGuilty">
                <div className="col-md-12 col-lg-6 contenedorgeneral" >
                  <div className="planesfuturo">
                    <div height='100%'>
                      <Typography variant="h3" className="TituloPlanesFuturo itacaBlack">
                        Planes funerarios a futuro
                      </Typography>
                      <Typography variant="h4" className="SubtituloNustrosServicios"  >
                        Una decisión de amor, no de urgencia, compra tu plan a futuro.
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={ImgPlanFuturo} style={{ borderRadius: '20px', width: '100%' }} alt="Imagen plan futuro" />
                      </Box>


                      <Typography className="ContenidoPlanesFuturo AlbertBold Mt-20"   >
                        ¿Qué es un plan funerario a futuro?
                      </Typography>
                      <Typography className="ContenidoPlanesFuturo"  >
                        Es un servicio que contratas hoy para utilizar cuando llegue el momento, ya sea para ti o para un ser querido. Te permite dejar todo organizado con anticipación, evitando gastos imprevistos, decisiones difíciles y trámites en medio del dolor.
                      </Typography>
                      <List sx={{ padding: '0px', margin: '0px' }}>
                        <Typography className="ContenidoPlanesFuturo MBCPF MBCPF-T AlbertBold"  >
                          Beneficios que hacen la diferencia:
                        </Typography>
                        {ListPlanesFuturo.map((text, index) => (
                          <ListItem key={index} disableGutters sx={{ padding: '0px' }} className="MBCPF">
                            <ListItemIcon sx={{ minWidth: 24 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 18, color: '#D14081' }} />
                            </ListItemIcon>
                            <ListItemText sx={{ mt: 0, mb: 0 }} >
                              <Typography className="ContenidoPlanesFuturo  " >{text}</Typography>
                            </ListItemText>
                          </ListItem>
                        ))}
                      </List>
                    </div>

                    <StyleDragArea>
                      <button onClick={() => (this.setState({ Route: '/PlanesFuturo' }))} type="button" className="btn btn-block btn_consultar">Contrata ahora
                      </button>
                    </StyleDragArea>
                  </div>
                </div>
                <div className="col-md-12 col-lg-6 contenedorgeneral" >
                  <div className="setsfunerarios">
                    <div width='100%'>
                      <Typography variant="h3" className="TituloPlanesFuturo itacaBlack" >
                        Sets funerarios de necesidad inmediata
                      </Typography>
                      <Typography variant="h4" className="SubtituloNustrosServicios" >
                        Todo lo que necesitas para llevar a cabo tu servicio funeral.
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={ImgSetsFunerarios} style={{ borderRadius: '20px', width: '100%' }} alt="Imagen sets a futuro" />
                      </Box>

                      <Typography className="ContenidoPlanesFuturo AlbertBold Mt-20"  >
                        ¿Qué son los sets funerarios?
                      </Typography>
                      <Typography className="ContenidoPlanesFuturo" fontWeight='400 !important' >
                        Son servicios funerales que se necesitan de manera inmediata porque algún ser querido ha fallecido, estos son completamente integrales y permiten que no haya mas que preocuparse y todo lo dejen en manos de Columba.
                      </Typography>
                      <List sx={{ padding: '0px', margin: '0px' }}>
                        <Typography className="ContenidoPlanesFuturo MBCPF MBCPF-T  AlbertBold"  >
                          Beneficios que hacen la diferencia:
                        </Typography>
                        {ListSetsFunerarios.map((text, index) => (
                          <ListItem key={index} disableGutters sx={{ padding: '0px' }} className="MBCPF">
                            <ListItemIcon sx={{ minWidth: 24 }}>
                              <FiberManualRecordIcon sx={{ fontSize: 18, color: '#D14081' }} />
                            </ListItemIcon>
                            <ListItemText sx={{ mt: 0, mb: 0 }} >
                              <Typography className="ContenidoPlanesFuturo  mt-0" >{text}</Typography>
                            </ListItemText>
                          </ListItem>
                        ))}
                      </List>
                    </div>

                    <StyleDragArea style={{ paddingBottomBottom: '10px !important' }}>
                      <button onClick={() => (this.setState({ Route: '/SetsFunerarios' }))} type="button" className="btn btn-block btn_consultar ">Contrata ahora
                      </button>
                    </StyleDragArea>

                  </div>
                </div>
              </div>

              <Box className='ContendorFootherNuestrosServicios'>
                <Typography variant="h3" className="TituloFootherNuestrosServicios" >
                  En todos nuestros sets te apoyamos de principio a fin con los trámites de defunción con atención funeraria inmediata en Toluca las 24 horas.
                </Typography>
                <Typography variant="h2" className="ParrafoFootherNuestrosServicios AlbertSans">
                  En todos nuestros sets, te apoyamos de principio a fin con los trámites de defunción. *Cobertura de 50 km a la redonda de nuestras instalaciones, sin costo adicional.
                </Typography>
              </Box>
            </Container>
          </Box>



          <section className="ContenedorConmemoracion ">
            <Box sx={{ padding: { xs: '0% 16px', sm: '0% 6%', md: '0% 9%', lg: '0% 0%', xl: '0% 18%' } }}>
              <Box className="row" mr={0} ml={0} >
                <div className="col-md-12 text-center">
                  <Typography variant='h2' className="animate__animated animate__fadeIn animate__delay-1s  TituloConmemoracion">
                    Una despedida interactiva, cercana y sin barreras.
                  </Typography>
                </div>
              </Box>
              <Box className="row" mr={0} ml={0}>
                <Box className="col-lg-6 text-center videconmemoracion order-2 order-md-1">
                  <div className="ContenedorVideoConmemoracion">
                    <div onClick={this.ShowConmemoracion} data-toggle="modal" data-target="#myModal" className="videoConmemoracion" >
                      <video src={VideoConmemeracion} className="Conmemoracionvideo" controls muted autoPlay style={{ borderRadius: '15px', aspectRatio: '1' }}></video>
                    </div>
                    <StyleDragArea className="ConmemoracionBotton2">
                      <button onClick={() => (this.setState({ Route: '/Conmemoraciones' }))} type="button" className="btn btn-block btn_consultar ">Ver más</button>
                    </StyleDragArea>
                  </div>

                </Box>
                <Box sx={{ padding: { xs: '0px 13px', sm: '0px 0px 0px 0px' } }} className="col-lg-6  order-1 order-md-2">
                  <Typography className=" ParrafoConmemoracion" pr='10px' >
                    A través de la conmemoración digital, familiares, amigos y personas cercanas podrán participar activamente
                    en la despedida de su ser querido, sin importar dónde se encuentren, mediante mensajes de despedida,
                    recuerdos o palabras de aliento.
                  </Typography>



                  <List dense sx={{ padding: '0px' }}>
                    <Typography className=" SubTituloConmemoracion AlbertBold" >
                      Por su parte, los familiares autorizados pueden:
                    </Typography>
                    {['Subir fotos', 'Compartir videos', 'Compartir memorias'].map((text, index) => (
                      <ListItem key={index} disableGutters sx={{ padding: '0px', marginBottom: '20px' }}>
                        <ListItemIcon sx={{ minWidth: 24 }}>
                          <FiberManualRecordIcon sx={{ fontSize: 18, color: '#D14081' }} />
                        </ListItemIcon>
                        <ListItemText sx={{ padding: '0px', margin: '0px' }}>
                          <Typography sx={{ padding: '0px', margin: '0px', lineHeight: '1' }} className="ListConmemoracion AlbertBold" >{text}</Typography>
                        </ListItemText>
                      </ListItem>
                    ))}
                  </List>
                  <StyleDragArea className="ConmemoracionBotton1">
                    <button onClick={() => (this.setState({ Route: '/Conmemoraciones' }))} type="button" className="btn btn-block btn_consultar">Ver más</button>
                  </StyleDragArea>
                </Box>
              </Box>
            </Box>
          </section>

          <Container maxWidth='lg'>
            <div className="row ">
              <div className="col-md-12  text-center">
                <Typography variant="h2" className="TituloBeneficios">
                  Beneficios al comprar un servicio funeral en línea.
                </Typography>
              </div>
            </div>
            <div className="row">
              <Box className="col-md-12  text-center" sx={{ padding: { xs: '0% 0%', sm: '0% 4%', md: '0% 6%', lg: '0% 8%', xl: '0% 10%' } }}>
                <Typography className=" ParrafoBeneficios">
                  Estamos transformando la manera de vivir el duelo, haciéndolo más fácil, accesible y humano, sin perder el respeto y la calidez que merecen estos momentos.
                  Aquí te compartimos las ventajas de elegirnos.
                </Typography>
              </Box>
            </div>
          </Container>
          <Container maxWidth='lg' className="seccionX">
            <section className="ContenedorSets ContenedorTarjetaBenefecios" >
              <div className='row  gx-5 gy-3' style={{ width: '100%' }}>
                {
                  ListBeneficion.map((item, index) => (
                    <div key={index} className="col-sm-6  col-lg-4 text-center mb-2 seccionX">
                      <TarjetaBeneficios Margin={{ [theme.breakpoints.down(576)]: { margin: '10px 40px' }, [theme.breakpoints.up(576)]: { margin: '10px 20px' } }} Padding={{ [theme.breakpoints.down(576)]: { padding: '0px 0px 78px 0px' }, [theme.breakpoints.up(576)]: { padding: '0px 0px 48px 0px' } }} ParrafoSize={{ [theme.breakpoints.down(576)]: { fontSize: '16px' }, [theme.breakpoints.up(576)]: { fontSize: '18px' } }} Imagen={item.Imagen} ColorTarjeta={item.ColorTarjeta} TituloContenido={item.TituloContenido} ParrafoContenido={item.ParrafoContenido} />
                    </div>
                  ))
                }
              </div>
            </section>
          </Container>
          <ModalBaseMui Title='' Open={this.state.Conmemoracion} FullScreen={false} OnClickClose={this.ShowConmemoracion} FullWidth={true} MaxWidth='sm'
            ContentModal={
              <div className="modal-body pt-0">
                <h5 className="color_ros modal-title text-center pb-3" id="exampleModalLabel">¿Qué es una conmemoración?</h5>
                <div className="" style={{ padding: '0% 0%' }}>
                  <video src={VideoConmemeracionModal} width="100%" controls muted autoPlay style={{ borderRadius: '15px' }}></video>
                </div>
              </div>
            }

          />



          <Container className="Call">
            <ImageListItem sx={{ width: '100%' }}>
              <img alt="imagen fondo" src={CallTO} />
              <Box className='CallMaster' >
                <Box className="CallLeft">
                </Box>
                <Box className="CallRight">
                  <Typography variant="h2" className="CallTitle">
                    Comienza una despedida significativa y simplificada.
                  </Typography>

                  <Typography className="CallParrafo">
                    Diseña una despedida <Typography className="CallParrafo M-0 AlbertBold ">significativa y simplificada, desde donde te sientas en paz.</Typography>  Siempre tendrás a un asesor humano contigo, paso a paso.
                  </Typography>

                  <Box className='CallButton'>
                    <StyleDragArea>
                      <button onClick={() => (this.setState({ Route: '/SetsFunerarios' }))} className="btn btn_consultarV3 boton-con-imagen" id="CallButtonOnly">Comienza ahora <span className="img-container" /></button>
                    </StyleDragArea>
                  </Box>
                </Box>
              </Box>
            </ImageListItem>
          </Container>

          <Box className='CallMovil'>
            <Box className="CallRight">
              <Typography variant="h2" className="CallTitle">
                Comienza una despedida significativa y simplificada.
              </Typography>

              <Typography className="CallParrafo">
                Diseña una despedida <Typography className="CallParrafo M-0 AlbertBold  ">significativa y simplificada, desde donde te sientas en paz.</Typography>  Siempre tendrás a un asesor humano contigo, paso a paso.
              </Typography>

              <img alt="imagen fondo" className="CallImagen" src={CallToMovil} />

              <Box className='CallButton'>
                <StyleDragArea>
                  <button onClick={() => (this.setState({ Route: '/SetsFunerarios' }))} className="btn btn_consultarV3 boton-con-imagen" id="CallButtonOnly">Comienza ahora  <span className="img-container" /></button>
                </StyleDragArea>
              </Box>
            </Box>
          </Box>

          <div className="scroll-to-top scroll-to-target" data-target=".header-top">
            <span href='#ancla-1' className="icon fa fa-angle-up"></span>
          </div>


        </div>


      </Box>

    );
  }
}

export default Home;